var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPremiumAlternative = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#12C0AB",
  fillRule: "evenodd",
  d: "M13.679 5.552a.69.69 0 0 1 .654-.472h5.753c.27 0 .515.16.629.408a.71.71 0 0 1-.102.749l-9.697 11.516a.69.69 0 0 1-.871.154.706.706 0 0 1-.31-.84zm1.147.931-2.577 7.525 6.336-7.525zM4.822.01c.249.044.455.22.537.462l1.74 5.08a.71.71 0 0 1-.09.637.69.69 0 0 1-.564.295H.693a.69.69 0 0 1-.625-.398.71.71 0 0 1 .084-.742L4.164.264c.158-.2.41-.297.658-.254M2.134 5.08h3.338l-1.01-2.947z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#12C0AB",
  fillRule: "evenodd",
  d: "M15.956.01c.248-.043.5.054.658.253l4.012 5.081c.166.21.199.5.084.742a.69.69 0 0 1-.625.398h-5.752a.69.69 0 0 1-.564-.295.71.71 0 0 1-.09-.637l1.74-5.08a.7.7 0 0 1 .537-.462m.36 2.123-1.01 2.948h3.338z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#12C0AB",
  fillRule: "evenodd",
  d: "M10.389 0a.69.69 0 0 1 .544.268l3.944 5.08a.71.71 0 0 1 .079.74.69.69 0 0 1-.623.396H6.445a.69.69 0 0 1-.623-.395.71.71 0 0 1 .078-.74L9.844.268A.69.69 0 0 1 10.39 0M7.87 5.08h5.036L10.39 1.838z",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#12C0AB",
  fillRule: "evenodd",
  d: "M4.14.295A.69.69 0 0 1 4.705 0h5.684c.265 0 .507.153.623.395a.71.71 0 0 1-.079.74L6.99 6.216a.688.688 0 0 1-1.198-.204L4.05.932a.71.71 0 0 1 .09-.637m1.538 1.108L6.684 4.34l2.28-2.936z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#12C0AB",
  fillRule: "evenodd",
  d: "M9.766.395A.69.69 0 0 1 10.39 0h5.684a.69.69 0 0 1 .565.295.71.71 0 0 1 .09.637l-1.74 5.08a.688.688 0 0 1-1.199.204l-3.944-5.08a.71.71 0 0 1-.079-.74m2.049 1.008 2.28 2.936L15.1 1.403z",
  clipRule: "evenodd"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#12C0AB",
  fillRule: "evenodd",
  d: "M5.88 5.375a.69.69 0 0 1 .565-.295h7.888a.69.69 0 0 1 .564.295.71.71 0 0 1 .09.637l-3.944 11.516a.69.69 0 0 1-.654.472.69.69 0 0 1-.654-.472L5.79 6.012a.71.71 0 0 1 .09-.637m1.538 1.108 2.97 8.674 2.972-8.674z",
  clipRule: "evenodd"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#12C0AB",
  fillRule: "evenodd",
  d: "M.064 5.488a.69.69 0 0 1 .629-.408h5.752c.295 0 .558.19.654.472l3.944 11.516a.706.706 0 0 1-.31.839.686.686 0 0 1-.87-.154L.165 6.237a.71.71 0 0 1-.102-.75m2.13.995 6.335 7.525-2.577-7.525z",
  clipRule: "evenodd"
})));
export default SvgPremiumAlternative;